// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"f19516d7","69":"6d22b7d3","78":"0d854822","835":"f7e68d62"}[chunkId] + ".css";
};